export const getPositionText = (position) => {
  switch (position) {
    case 25:
    case 13:
      return "C";
    case 28:
    case 15:
      return "RW";
    case 29:
    case 16:
      return "LW";
    case 26:
    case 27:
    case 14:
      return "D";
    case 30:
      return "F";
    case 24:
    case 0:
      return "T";
    default:
      return position ? position.toString() : "N/A";
  }
};

export const getCardStyling = (rating) => {
  switch (rating) {
    case 0:
      return {
        bgcolor: "grey",
        border: "1px solid #424242",
        color: "white",
      };
    case 1:
      return {
        bgcolor: "#C0C0C0",
        border: "2px solid #3f3f3f",
        color: "white",
      };
    case 2:
      return {
        bgcolor: "#ffd700",
        border: "2px solid #b8860b",
        color: "white",
        boxShadow: "0 0 8px #ff9800",
      };
    case 3:
      return {
        bgcolor: "#9c27b0",
        border: "2px solid #4a148c",
        color: "white",
        boxShadow: "0 0 8px #7b1fa2",
      };
    default:
      return {
        bgcolor: "#9e9e9e",
        border: "2px solid #424242",
        color: "white",
      };
  }
};
